<template>
	<div class="w-full h-full">
		<div v-if="permissionOnButton(3) || permissionOnButton(41) || permissionOnButton(105)">
			<div class="w-3/4 m-auto font-medium text-2xl pb-3 document-page-title">{{$t('message.main_document_page.document.title_document')}}</div>
			<div class="flex w-3/4 m-auto main-porlet">
				<div v-if="permissionOnButton(3)" @click="redirect(3)" class="bg-white flex rounded items-center w-1/2 mr-2 shadow-md hover:shadow-lg cursor-pointer porlet">
					<div class="w-1/2 p-3">
						<DocumentLogoSVG/>
					</div>
					<div class="w-11/12 p-2">
						<p class="font-medium text-xl mb-3 text-zt-dark-400 porlet-title">{{$t('message.main_document_page.document.search_document')}}</p>
						<span class="text-zt-dark-300"> {{$t('message.main_document_page.document.subtitle_search_document')}}</span>
					</div>
					<div class="w-1/12 porlet-icon">
						<zt-icon name="angle-right-solid" />
					</div>
				</div>
				<div v-if="permissionOnButton(105) &&  permissionOnButton(41)" @click="redirect(105)" class="flex rounded items-center w-1/2 ml-2 bg-white shadow-md hover:shadow-lg cursor-pointer porlet">
					<div class="w-1/2 p-3">
						<PublishLogoSVG/>
					</div>
					<div class="w-11/12 p-2">
						<h1 class="font-medium text-xl mb-3 text-zt-dark-400 porlet-title">{{$t('message.main_document_page.document.publish')}}</h1>
						<span class="text-zt-dark-300"> {{$t('message.main_document_page.document.subtitle_publish')}}</span>
					</div>
					<div class="w-1/12 porlet-icon">
						<zt-icon name="angle-right-solid" />
					</div>
				</div>
				<div v-else-if="permissionOnButton(41)" @click="redirect(41)" class="flex rounded items-center w-1/2 ml-2 bg-white shadow-md hover:shadow-lg cursor-pointer porlet">
					<div class="w-1/2 p-3">
						<PublishLogoSVG/>
					</div>
					<div class="w-11/12 p-2">
						<h1 class="font-medium text-xl mb-3 text-zt-dark-400 porlet-title">{{$t('message.main_document_page.document.publish')}}</h1>
						<span class="text-zt-dark-300"> {{$t('message.main_document_page.document.subtitle_publish')}}</span>
					</div>
					<div class="w-1/12 porlet-icon">
						<zt-icon name="angle-right-solid" />
					</div>
				</div>
			</div>
		</div>
		<div v-if="permissionOnButton(4) || permissionOnButton(50) || permissionOnButton(302)">
			<div class="w-3/4 m-auto font-medium text-2xl pb-3 document-page-title">{{$t('message.main_document_page.publish.title_publish')}}</div>
      <div class="flex w-3/4 m-auto secondaryPorlet">
        <div v-if="permissionOnButton(4)" @click="redirect(4)" class="flex rounded w-1/3 mr-2 p-4 bg-white shadow-md hover:shadow-lg rounded-md items-center cursor-pointer porlet">
					<div class="w-11/12">
						<h1 class="font-medium text-xl mb-3 text-zt-dark-400 porlet-title">{{$t('message.main_document_page.publish.individual')}}</h1>
						<span class="text-zt-dark-300 w-3/4 block">{{$t('message.main_document_page.publish.subtitle_individual')}}</span>
					</div>
					<div class="w-1/12 porlet-icon">
						<zt-icon name="angle-right-solid" />
					</div>
				</div>
        <div v-if="permissionOnButton(302)" @click="redirect(302)" class="flex rounded w-1/3 ml-2 mr-2 p-4 bg-white shadow-md hover:shadow-lg rounded-md items-center cursor-pointer porlet">
          <div class="w-11/12">
            <h1 class="font-medium text-xl mb-3 text-zt-dark-400 porlet-title">{{$t('message.main_document_page.publish.generic')}}</h1>
            <span class="text-zt-dark-300 w-3/4 block">{{$t('message.main_document_page.publish.subtitle_generic')}}</span>
          </div>
          <div class="w-1/12 porlet-icon">
            <zt-icon name="angle-right-solid" />
          </div>
        </div>
        <!-- generic-->
        <div v-if="permissionOnButton(50)" @click="redirect(50)" class="flex rounded w-1/3 ml-2 mr-2 p-4 bg-white shadow-md hover:shadow-lg rounded-md items-center cursor-pointer porlet">
					<div class="w-11/12">
						<h1 class="font-medium text-xl mb-3 text-zt-dark-400 porlet-title">{{$t('message.main_document_page.publish.signature_reminder')}}</h1>
						<span class="text-zt-dark-300 w-3/4 block">{{$t('message.main_document_page.publish.title_signature_reminder')}}</span>
					</div>
					<div class="w-1/12 porlet-icon">
						<zt-icon name="angle-right-solid" />
					</div>
				</div>
			</div>
		</div>
		<div v-if="permissionOnButton(62)">
			<div class="w-3/4 m-auto font-medium text-2xl pb-3 document-page-title">{{$t('message.main_document_page.forms.title_publish')}}</div>
			<div class="flex w-3/4 m-auto secondaryPorlet">
				<div @click="redirect('eforms')" class="flex rounded w-1/3 mr-2 p-4 bg-white shadow-md hover:shadow-lg rounded-md items-center cursor-pointer porlet">
					<div class="w-11/12">
						<h1 class="font-medium text-xl mb-3 text-zt-dark-400 porlet-title">{{$t('message.main_document_page.forms.publish_forms')}}</h1>
						<span class="text-zt-dark-300 w-3/4 block">{{$t('message.main_document_page.forms.subtitle_publish_forms')}}</span>
					</div>
					<div class="w-1/12 porlet-icon">
						<zt-icon name="angle-right-solid" />
					</div>
				</div>
				<div @click="redirect('published')" class="flex rounded w-1/3 ml-2 mr-2 p-4 bg-white shadow-md hover:shadow-lg rounded-md items-center cursor-pointer porlet">
					<div class="w-11/12">
						<h1 class="font-medium text-xl mb-3 text-zt-dark-400 porlet-title">{{$t('message.main_document_page.forms.published_forms')}}</h1>
						<span class="text-zt-dark-300 w-3/4 block">{{$t('message.main_document_page.forms.subtitle_published_forms')}}</span>
					</div>
					<div class="w-1/12 porlet-icon">
						<zt-icon name="angle-right-solid" />
					</div>
				</div>
				<div @click="redirect('pickup')" class=" flex rounded w-1/3 ml-2 mr-2 p-4 bg-white shadow-md hover:shadow-lg rounded-md items-center cursor-pointer porlet">
					<div class="w-11/12">
						<h1 class="font-medium text-xl mb-3 text-zt-dark-400 porlet-title">{{$t('message.main_document_page.forms.config_forms')}}</h1>
						<span class="text-zt-dark-300 w-3/4 block">{{$t('message.main_document_page.forms.subtitle_config_forms')}}</span>
					</div>
					<div class="w-1/12 porlet-icon">
						<zt-icon name="angle-right-solid" />
					</div>
				</div>
			</div>
		</div>
		<div v-if="permissionOnButton(19) || permissionOnButton(41) || permissionOnButton(62) || permissionOnButton(50) || permissionOnButton(95)">
			<div class="w-3/4 m-auto font-medium text-2xl pb-3 document-page-title">{{$t('message.main_document_page.management.title_management')}}</div>
			<div class="flex w-3/4 m-auto secondaryPorlet">
				<div v-if="permissionOnButton(19)" @click="redirect(19)" class="flex rounded w-1/3 mr-2 p-4 bg-white shadow-md hover:shadow-lg rounded-md items-center cursor-pointer porlet">
					<div class="w-11/12">
						<h1 class="font-medium text-xl mb-3 text-zt-dark-400 porlet-title">{{$t('message.main_document_page.management.publish_title_management')}}</h1>
						<span class="text-zt-dark-300 w-3/4 block">{{$t('message.main_document_page.management.subtitle_publish_title_management')}}</span>
					</div>
					<div class="w-1/12 porlet-icon">
						<zt-icon name="angle-right-solid" />
					</div>
				</div>
				<div v-if="permissionOnButton(41) || permissionOnButton(62) || permissionOnButton(50) || permissionOnButton(95)" @click="redirect('procesos')" class="flex rounded w-1/3 ml-2 mr-2 p-4 bg-white shadow-md hover:shadow-lg rounded-md items-center cursor-pointer porlet">
					<div class="w-11/12">
						<h1 class="font-medium text-xl mb-3 text-zt-dark-400 porlet-title">{{$t('message.main_document_page.management.process_status')}}</h1>
						<span class="text-zt-dark-300 w-3/4 block">{{$t('message.main_document_page.management.subtitle_process_status')}}</span>
					</div>
					<div class="w-1/12 porlet-icon">
						<zt-icon name="angle-right-solid" />
					</div>
				</div>
				<div class="w-1/3"></div>
			</div>
		</div>
	</div>
</template>

<script>
import DocumentLogoSVG from '../views/SVG/DocumentLogoSVG'
import PublishLogoSVG from '../views/SVG/PublishLogoSVG'

export default {
	name:'MainDocumentPage',
	components:{
		DocumentLogoSVG,
		PublishLogoSVG
	},
	methods:{
		permissionOnButton(id) {
			if (!this.$store.state.permissions) return false

			if (this.$store.state.permissions.length > 0) {
				if (this.$store.state.permissions.includes(id)) return true
			}

			return false;
		},
		redirect(id) {
			if (id === 3) this.$router.push( {path: '/documents/search'} )
			if (id === 41) this.$router.push( {path: '/documents/publish/massive'} )
			if (id === 105) this.$router.push( {path: '/documents/publish/massive'} )
      if (id === 4) this.$router.push( {path: '/documents/publish/personal'} )
      if (id === 302) this.$router.push( {path: '/documents/publish/generic'} ) // generic
			if (id === 50) this.$router.push({ path: '/documents/publish/signature-reminder' })
			if (id === 'eforms') window.location.href = "/eforms"
			if (id === 'published') this.$router.push( {path: '/publishedEforms'} )
			if (id === 'pickup') this.$router.push( {path: '/pickup'} )
			if (id === 19) window.location.href = window.origin + '/v3/publish/undo'
			if (id === 'procesos') this.$router.push( {path: '/company/process-manager'} )
		}
	}
}
</script>

<style lang="scss" scoped>
@import "./public/assets/scss/_config.scss";
.document-page-title{
	color:#707070;
}

.porlet:hover {
	.porlet-title{
		color: $blue-primary;
	}
	.porlet-icon{
		color: $blue-primary;
	}
}

.main-porlet{
	height: 233px;
	margin-bottom: 2% !important;
	border-radius: 25px;
}
.secondaryPorlet {
	height: 140px;
	margin-bottom: 2% !important;
}
</style>
